import styled from 'styled-components';

export const Wrapper = styled.div<{ sticky: boolean }>`
  padding: 16px 32px;
  background-color: var(--colorBlueGray200);
  position: ${({ sticky }) => (sticky ? 'sticky' : 'relative')};
  z-index: ${({ sticky }) => (sticky ? '2' : '0')};
  top: ${({ sticky }) => (sticky ? '0' : 'auto')};

  & + & {
    padding-top: 0;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const IconWrapper = styled.div<{ isRight?: boolean }>`
  color: var(--colorBlueGray600);
  position: absolute;
  left: ${({ isRight }) => (isRight ? 'auto' : '12px')};
  right: ${({ isRight }) => (isRight ? '12px' : 'auto')};
  top: 50%;
  transform: translateY(-50%);
  height: 18px;
  width: 18px;

  svg {
    height: 100%;
    width: 100%;
  }
`;

export const Input = styled.input`
  border-radius: 16.5px;
  border: 1px solid rgb(213, 215, 216);
  font-size: 14px;
  padding: 4px 32px;
  height: 32px;
  line-height: 1.16em;
  width: 100%;
  color: var(--colorBlueGray1200);

  &::placeholder {
    color: var(--colorBlueGray600);
  }

  &:focus-visible {
    outline: none;
  }
`;

export const StorybookWrapper = styled.div`
  width: 500px;
`;
